import { render, staticRenderFns } from "./CompTimeBenefitsAdvices.vue?vue&type=template&id=57c8bfc8&scoped=true"
import script from "./CompTimeBenefitsAdvices.vue?vue&type=script&setup=true&lang=js"
export * from "./CompTimeBenefitsAdvices.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c8bfc8",
  null
  
)

export default component.exports